import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import ProgramsPage from './pages/ProgramsPage';
import WorkoutPage from './pages/WorkoutPage';
import ExercisePage from './pages/ExercisePage';
import PreWorkoutPage from './pages/PreWorkoutPage';
import HistoryPage from './pages/HistoryPage';
import SessionDetailPage from './pages/SessionDetailPage';
import ExerciseHistoryPage from './pages/ExerciseHistoryPage';
import TechniquePage from './pages/TechniquePage';

const protect = (el: React.ReactNode) => <ProtectedRoute>{el}</ProtectedRoute>;

const router = createBrowserRouter([
  { path: '/', element: <HomePage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/profile', element: protect(<ProfilePage />) },
  { path: '/programs', element: protect(<ProgramsPage />) },
  // The workout runner: overview, then one page per exercise.
  { path: '/workout/:sessionId', element: protect(<WorkoutPage />) },
  // Declared before the :exerciseIndex route so "warmup" is not read as an index.
  { path: '/workout/:sessionId/warmup', element: protect(<PreWorkoutPage />) },
  { path: '/workout/:sessionId/:exerciseIndex', element: protect(<ExercisePage />) },
  { path: '/history', element: protect(<HistoryPage />) },
  { path: '/history/:sessionId', element: protect(<SessionDetailPage />) },
  { path: '/exercise/:name', element: protect(<ExerciseHistoryPage />) },
  { path: '/technique/:techniqueId', element: protect(<TechniquePage />) },
  { path: '*', element: <HomePage /> },
]);

function App() {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </AuthProvider>
  );
}

export default App;
